import { Exclude, Expose, Type } from 'class-transformer';
export function ResponseSerialize(func) {
    return Type(function () { return func; });
}
export function ResponseExpose(name) {
    return Expose({ name: name, toClassOnly: true });
}
export function RequestExpose(name) {
    return Expose({ name: name, toPlainOnly: true });
}
export function HttpExpose(name) {
    return Expose({ name: name });
}
export function RequestExclude() {
    return Exclude({ toPlainOnly: true });
}
export function ResponseExclude() {
    return Exclude({ toClassOnly: true });
}
export function HttpExclude() {
    return Exclude();
}
//# sourceMappingURL=http.decorator.js.map